import { useNavigate } from 'react-router-dom';
import { ArrowLeft, AlertTriangle } from 'lucide-react';
import { TERMINOS, PRIVACIDAD, LEGAL_VERSION, LEGAL_FECHA, LEGAL_PRELIMINAR } from '@/data/legal';

const LOGO = "https://customer-assets.emergentagent.com/job_9b5e32bd-6e03-4600-841f-a63162f850e8/artifacts/w487gkes_lexorbit-logo.png.png";

export default function LegalPage({ tipo }) {
  const navigate = useNavigate();
  const esTerminos = tipo === 'terminos';
  const secciones = esTerminos ? TERMINOS : PRIVACIDAD;
  const titulo = esTerminos ? 'Términos y Condiciones' : 'Política de Privacidad';

  return (
    <div className="min-h-screen bg-[#070707] text-[#E8E8E8] px-4 py-10">
      <div className="max-w-3xl mx-auto">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-[#C9A44C] hover:text-[#E0C878] text-sm mb-6">
          <ArrowLeft className="w-4 h-4" /> Volver
        </button>

        <div className="flex items-center gap-3 mb-2">
          <img src={LOGO} alt="LexOrbit" className="h-10" />
          <h1 className="text-2xl text-[#F8F6F0]" style={{ fontFamily: 'Playfair Display, serif' }}>{titulo}</h1>
        </div>
        <p className="text-xs text-[#888] mb-6">Versión {LEGAL_VERSION} — {LEGAL_FECHA} · República Argentina</p>

        {LEGAL_PRELIMINAR && (
          <div className="flex items-start gap-2 px-4 py-3 mb-7 rounded-xl border border-[#C9A44C]/30 bg-[#C9A44C]/[0.06]">
            <AlertTriangle className="w-4 h-4 text-[#C9A44C] shrink-0 mt-0.5" />
            <p className="text-[12px] text-[#D8D1C3] leading-relaxed">
              Versión preliminar sujeta a la aprobación final de un profesional del derecho matriculado.
              El texto vigente al momento de tu registro es el que aceptás y queda registrado con su versión y fecha.
            </p>
          </div>
        )}

        <div className="space-y-5">
          {secciones.map((s, i) =>
            s.h ? (
              <h2 key={i} className="text-[#C9A44C] text-lg font-semibold pt-4" style={{ fontFamily: 'Playfair Display, serif' }}>{s.h}</h2>
            ) : (
              <div key={i}>
                <h3 className="text-[#E0C878] text-sm font-semibold mb-1">{s.t}</h3>
                <p className="text-[13px] text-[#C8C8C8] leading-relaxed text-justify">{s.p}</p>
              </div>
            )
          )}
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 text-center">
          <p className="text-xs text-[#666]">
            {esTerminos
              ? <>¿Buscás la <a href="/privacidad" className="text-[#C9A44C] hover:text-[#E0C878] underline">Política de Privacidad</a>?</>
              : <>¿Buscás los <a href="/terminos" className="text-[#C9A44C] hover:text-[#E0C878] underline">Términos y Condiciones</a>?</>}
          </p>
          <p className="text-[10px] text-[#555] mt-3">© 2026 LexOrbit. Todos los derechos reservados.</p>
        </div>
      </div>
    </div>
  );
}
